/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module ApplicationProfileModule
 */

import { Injector } from '@angular/core';

import {
    ApplicationProfileCollection,
} from 'ajs/modules/application-profile/factories/application-profile.collection.factory';

import {
    APPLICATION_PROFILE_COLLECTION_TOKEN,
} from 'ajs/modules/application-profile/application-profile.tokens';

const $injector = '$injector';

export const applicationProfileCollectionProvider = {
    deps: [$injector],
    provide: ApplicationProfileCollection,
    useFactory(injector: Injector): typeof ApplicationProfileCollection {
        return injector.get(APPLICATION_PROFILE_COLLECTION_TOKEN);
    },
};
